import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { ActionCard } from '../../../Models/ActionCard';

interface cardMapInterface {
  cardMap: { [key: string]: ActionCard };
}

const initialState:cardMapInterface = {
  cardMap: {}
}

export const paymentCardsByChannelSlice = createSlice({
  name: 'channelPaymentCardMap',
  initialState,
  reducers: {
    setCardMap: (state, action: PayloadAction<ActionCard[]>) => {
      state.cardMap = {}
      action.payload.forEach((card: ActionCard) => {
        let actionCard = new ActionCard(card);
        state.cardMap[actionCard.id] = actionCard;
      })
    },
    resetCardMap: (state) => {
      state.cardMap = {}
    },
  },
})

// Action creators are generated for each case reducer function
export const { resetCardMap, setCardMap } = paymentCardsByChannelSlice.actions

export default paymentCardsByChannelSlice.reducer